// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/inactiveContractIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Inactive" aria-label="Inactive" />;
}
